import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 60000,
});

export const TOKEN_KEY = "hotelos.auth.token";
export const USER_KEY = "hotelos.auth.user";

let onUnauthorized = null;
export function setOnUnauthorized(fn) {
    onUnauthorized = fn;
}

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
            if (onUnauthorized) onUnauthorized();
        }
        return Promise.reject(err);
    },
);
